import BookOutlined from '@mui/icons-material/BookOutlined';
import { Stack, Typography } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import AccessEventsDataGrid, { AccessEventRow } from 'v2/components/AccessEventsDataGrid/AccessEventsDataGrid';
import EmptyStateOverview from 'v2/components/EmptyStateOverview/EmptyStateOverview';
import OverviewContent from 'v2/components/OverviewContent/OverviewContent';
import useSnackbarContext from 'v2/components/Snackbar/useSnackbarContext';
import useDeviceDetailsAccessEvents from 'v2/hooks/useDevices/useDeviceDetailsAccessEvents';

interface Props {
  deviceId: string;
}

const AccessEventsTab: React.FC<Props> = ({ deviceId }) => {
  const { translation } = useTranslation();
  const { showSnackbar } = useSnackbarContext();
  const handleFetchError = (errorMessage: string) => showSnackbar(errorMessage, { severity: 'error' });

  const { deviceDetailsAccessEvents, loadingGetDeviceDetailsAccessEvents } = useDeviceDetailsAccessEvents({
    handleFetchError,
    deviceId
  });

  const rows: AccessEventRow[] = (deviceDetailsAccessEvents ?? []).map((event) => ({
    id: event.id,
    createdAt: event.createdAt,
    visitorName: event.visitor.name,
    visitorEmail: event.visitor.email,
    action: event.action,
    reason: event.reason
  }));

  const hasEvents = rows.length > 0;

  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      <Typography variant="h5" color="textPrimary">
        {translation.events}
      </Typography>
      <OverviewContent
        loading={loadingGetDeviceDetailsAccessEvents}
        hasData={hasEvents}
        hasResults={hasEvents}
        table={
          <AccessEventsDataGrid
            className="background-level2 not-clickable"
            rows={rows}
            loading={loadingGetDeviceDetailsAccessEvents}
            hideDeviceColumn
          />
        }
        noResults={null}
        noData={
          <EmptyStateOverview
            icon={BookOutlined}
            title={translation.device_has_no_events}
            content={translation.no_access_events_tied_to_device}
            sx={{ height: 'auto', pt: 8, pb: 4 }}
          />
        }
      />
    </Stack>
  );
};

export default AccessEventsTab;
